var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 11H16.0714V9.07143C16.0714 6.84821 14.2232 5 12 5C9.75 5 7.92857 6.84821 7.92857 9.07143V11H7.28571C6.5625 11 6 11.5893 6 12.2857V17.4286C6 18.1518 6.5625 18.7143 7.28571 18.7143H16.7143C17.4107 18.7143 18 18.1518 18 17.4286V12.2857C18 11.5893 17.4107 11 16.7143 11ZM13.9286 11H10.0714V9.07143C10.0714 8.02679 10.9286 7.14286 12 7.14286C13.0446 7.14286 13.9286 8.02679 13.9286 9.07143V11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c5b02ea2bd9b9ce83ad50fbd6c9f1799.svg";
export { ForwardRef as ReactComponent };